import React from 'react';

import { ExcludesNull } from 'types/excludesNull';
import { PrismicCardsFields } from 'types/prismicSlices';
import { Grid } from 'components/grid/Grid';
import { FileCard } from 'components/file-card/FileCard';
import { linkResolver } from 'utils/linkResolver';
import { asText, RichText } from '../../components/rich-text/RichText';
import { mapColor } from '../../types/placeholderColors';

interface ICardsContainer {
  columns?: 2 | 3;
  items: PrismicCardsFields[];
  isColumnLayout?: boolean;
}

export const CardsContainer = ({ columns, items, isColumnLayout = true }: ICardsContainer) => {
  if (items.length === 0) {
    return null;
  }

  const cards: JSX.Element[] = items
    .map((item: PrismicCardsFields, i: number) => {
      if (!item.title1) {
        return null;
      }

      return (
        <FileCard
          key={i}
          heading={asText(item.title1)}
          link={linkResolver(item.link)}
          linkText={asText(item.link_title)}
          meta={item.metadata1 ? <RichText>{item.metadata1}</RichText> : null}
          size={item.size === 'large' ? 'large' : 'default'}
          color={mapColor(item.color)}
        />
      );
    })
    .filter((Boolean as any) as ExcludesNull);

  return (
    <Grid isColumnLayout={isColumnLayout} limitColumns={false} columns={columns}>
      {cards}
    </Grid>
  );
};
